var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zy-chart-ring",style:({ height: _vm.height })},[_c('canvas',{ref:"charts",attrs:{"width":this.canvas_width,"height":this.canvas_height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }